import React, { createContext, useState, useEffect, useContext } from 'react';
import { sv } from './translations/sv';
import { en } from './translations/en';
import { es } from './translations/es';

const translations = { sv, en, es };

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => {
        try {
            return window.localStorage.getItem('noctra_language') || 'sv';
        } catch (e) {
            return 'sv';
        }
    });

    useEffect(() => {
        try {
            window.localStorage.setItem('noctra_language', language);
        } catch (e) { }
    }, [language]);

    const t = translations[language] || translations['sv'];

    return (
        <LanguageContext.Provider value={{ language, setLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};
